Add
<template>
  <div class="hero-head panel-heading soupe-ui-card-header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'soupe-ui-card-header'
}
</script>
